import React, { useEffect, useRef } from "react"
import mapboxgl from "mapbox-gl"

import "mapbox-gl/dist/mapbox-gl.css"
import { Link } from "eddev/routing"

export const Mapbox = ({ long, lat, link }: { long: number; lat: number; link?: string }) => {
  const mapContainerRef = useRef<HTMLDivElement>(null)
  const mapRef = useRef<mapboxgl.Map | null>(null)

  useEffect(() => {
    if (!mapContainerRef.current) return

    if (env.admin) return

    mapboxgl.accessToken =
      "pk.eyJ1IjoiZGFuaWVsLWVkIiwiYSI6ImNtOGlibHl5cjBiYmoybG9mZDZqM243MW8ifQ.fpVM6Xa3O-zD7zsx-m6oIQ"

    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      center: [long, lat], // starting position [lng, lat]
      zoom: 14, // starting zoom
      style: "mapbox://styles/daniel-ed/cl9w6kh2r000315mtet0z51an",
      attributionControl: false,
    })

    new mapboxgl.Marker({ color: "#000000" }).setLngLat([long, lat]).addTo(mapRef.current)
  }, [long, lat])

  const Wrap = link ? Link : "div"
  const wrapProps = link ? { href: link, target: "_blank" } : {}

  if (env.admin) {
    return (
      <div className="w-full aspect-[16/8] map-container bg-black/20 text-center justify-center items-center flex">
        Map goes here
      </div>
    )
  }

  return (
    <Wrap {...wrapProps} className="w-full">
      <div ref={mapContainerRef} className="map-container aspect-[16/8] pointer-events-none" />
    </Wrap>
  )
}
